/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Search = ({ color, height = 20, ...props }) => {
  return (
    <svg
      width={20}
      height={height}
      viewBox="0 0 20 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 18.586L18.586 20l-4.243-4.242 1.414-1.415L20 18.586zM8 14c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.309-2.692 6-6 6zM8 0a8 8 0 100 16A8 8 0 008 0z"
      />
    </svg>
  )
}

Search.propTypes = {
  color: string,
  height: number,
}

export default Search
